import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Walk_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 4.75C11.5858 4.75 11.25 5.08579 11.25 5.5C11.25 5.91421 11.5858 6.25 12 6.25C12.4142 6.25 12.75 5.91421 12.75 5.5C12.75 5.08579 12.4142 4.75 12 4.75ZM9.75 5.5C9.75 4.25736 10.7574 3.25 12 3.25C13.2426 3.25 14.25 4.25736 14.25 5.5C14.25 6.2983 13.8343 6.9995 13.2075 7.3989C13.2838 7.43267 13.3572 7.47173 13.4273 7.51563C13.4407 7.49987 13.4548 7.48454 13.4697 7.46967C13.7626 7.17678 14.2374 7.17678 14.5303 7.46967L17.5303 10.4697C17.8232 10.7626 17.8232 11.2374 17.5303 11.5303C17.2374 11.8232 16.7626 11.8232 16.4697 11.5303L14.25 9.31066V13C14.25 13.4556 14.0759 13.8705 13.7907 14.1818L14.7398 19.8767C14.8079 20.2853 14.5319 20.6717 14.1233 20.7398C13.7147 20.8079 13.3283 20.5319 13.2602 20.1233L12.3647 14.75H11.6353L10.7398 20.1233C10.6717 20.5319 10.2853 20.8079 9.8767 20.7398C9.46812 20.6717 9.19211 20.2853 9.2602 19.8767L10.2093 14.1818C9.92408 13.8705 9.75 13.4556 9.75 13V9.31066L7.53033 11.5303C7.23744 11.8232 6.76256 11.8232 6.46967 11.5303C6.17678 11.2374 6.17678 10.7626 6.46967 10.4697L9.46967 7.46967C9.76256 7.17678 10.2374 7.17678 10.5303 7.46967C10.5452 7.48454 10.5593 7.49987 10.5727 7.51563C10.6428 7.47173 10.7162 7.43267 10.7925 7.3989C10.1657 6.9995 9.75 6.2983 9.75 5.5ZM11.5 8.75C11.3619 8.75 11.25 8.86193 11.25 9V13C11.25 13.1381 11.3619 13.25 11.5 13.25H12.5C12.6381 13.25 12.75 13.1381 12.75 13V9C12.75 8.86193 12.6381 8.75 12.5 8.75H11.5Z"
            />
        </SvgStyled>
    );
};

export default Walk_md;
